"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setContextMenuVisibility_1 = require("../actions/setContextMenuVisibility");
var setRecipientSelectedState_1 = require("../actions/setRecipientSelectedState");
var setShouldBlockSelection_1 = require("../actions/setShouldBlockSelection");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Persona_1 = require("office-ui-fabric-react/lib/Persona");
var Utilities_1 = require("office-ui-fabric-react/lib/Utilities");
var PersonaControl_1 = require("owa-persona/lib/components/PersonaControl");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var React = require("react");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/ContextualMenu");
var KeyboardCharCodes_1 = require("owa-mail-hotkeys/lib/utils/KeyboardCharCodes");
var PersonaCardBehavior_1 = require("owa-persona/lib/components/PersonaCardBehavior");
var styles = require('./ReadWriteRecipient.scss');
var classNames = require('classnames/bind').bind(styles);
var SMTP_ROUTING_TYPE = 'SMTP';
var PRIVATE_DL_ROUTING_TYPE = 'PDL';
var ONE_OFF_MAILBOX_TYPE = 'OneOff';
var RIGHT_CLICK_BUTTONCODE = 2;
var ReadWriteRecipient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadWriteRecipient, _super);
    function ReadWriteRecipient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.removeRecipient = function () {
            setRecipientSelectedState_1.default(_this.props.viewState, false /* isSelected */);
            _this.props.removeOperation(_this.props.viewState);
        };
        _this.expandGroup = function () {
            setRecipientSelectedState_1.default(_this.props.viewState, false /* isSelected */);
            if (!_this.props.viewState.isExpanding) {
                _this.props.expandGroupOperation(_this.props.viewState);
            }
        };
        _this.onContextMenu = function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            setContextMenuVisibility_1.default(_this.props.viewState, true);
            setShouldBlockSelection_1.default(_this.props.viewState, false);
        };
        _this.onDismissContextMenu = function (ev) {
            ev.stopPropagation();
            setContextMenuVisibility_1.default(_this.props.viewState, false);
        };
        _this.onMouseDown = function (ev) {
            ev.stopPropagation();
            if (ev.button == RIGHT_CLICK_BUTTONCODE &&
                _this.props.viewState.isContextMenuOpen == false) {
                setShouldBlockSelection_1.default(_this.props.viewState, true);
            }
        };
        _this.onFocus = function (ev) {
            if (!_this.props.viewState.shouldBlockSelection) {
                setRecipientSelectedState_1.default(_this.props.viewState, true);
            }
        };
        _this.onBlur = function (ev) {
            setRecipientSelectedState_1.default(_this.props.viewState, false);
        };
        _this.onKeyDown = function (ev) {
            switch (ev.keyCode) {
                case KeyboardCharCodes_1.BACKSPACE_CHARCODE:
                    ev.stopPropagation();
                    if (!_this.props.viewState.blockRecipientRemoval) {
                        _this.props.removeOperation(_this.props.viewState);
                    }
                    return;
                case KeyboardCharCodes_1.DELETE_CHARCODE:
                    ev.stopPropagation();
                    if (!_this.props.viewState.blockRecipientRemoval) {
                        _this.props.removeOperation(_this.props.viewState, true /* selectToRight */);
                    }
                    return;
                case KeyboardCharCodes_1.LEFT_ARROW_CHARCODE:
                    ev.stopPropagation();
                    _this.props.focusNextOperation(_this.props.viewState, Utilities_1.getRTL() ? 1 : -1);
                    return;
                case KeyboardCharCodes_1.RIGHT_ARROW_CHARCODE:
                    ev.stopPropagation();
                    _this.props.focusNextOperation(_this.props.viewState, Utilities_1.getRTL() ? -1 : 1);
                    return;
                case KeyboardCharCodes_1.TAB_CHARCODE:
                    if (!ev.shiftKey) {
                        ev.preventDefault();
                        _this.props.focusNextOperation(_this.props.viewState, Utilities_1.getRTL() ? -1 : 1);
                        return;
                    }
            }
        };
        _this.copyAddress = function () {
            var email = _this.props.viewState.persona.EmailAddress;
            var copyText;
            if (email.RoutingType === SMTP_ROUTING_TYPE) {
                if (email.Name) {
                    var nameToUse = email.MailboxType == ONE_OFF_MAILBOX_TYPE
                        ? email.Name
                        : "\"" + email.Name.replace('"', '\\"') + "\"";
                    copyText = nameToUse + " <" + email.EmailAddress + ">";
                }
                else {
                }
            }
            else if (email.RoutingType === PRIVATE_DL_ROUTING_TYPE) {
                copyText = email.Name;
            }
            else {
                copyText = email.Name + " [" + email.RoutingType + ":" + email.EmailAddress + "]";
            }
            var copyInput = document.createElement('input');
            copyInput.className = styles.copyInput;
            document.body.appendChild(copyInput);
            try {
                // Try to copy the text directly to the clipboard
                copyInput.value = copyText;
                copyInput.select();
                if (!document.execCommand('copy')) {
                    // The command failed. Fallback to the method below.
                    throw new Error();
                }
            }
            catch (err) {
                // The above method didn't work. Fallback to a prompt.
                window.prompt(owa_common_strings_1.default.readWriteRecipient_CopyPrompt, copyText);
            }
            finally {
                document.body.removeChild(copyInput);
            }
        };
        return _this;
    }
    ReadWriteRecipient.prototype.setFocusIfSelected = function () {
        if (this.props.viewState.isSelected) {
            this.personaSpan.focus();
        }
    };
    ReadWriteRecipient.prototype.componentDidMount = function () {
        this.setFocusIfSelected();
    };
    ReadWriteRecipient.prototype.componentDidUpdate = function () {
        this.setFocusIfSelected();
    };
    ReadWriteRecipient.prototype.createContextMenuItems = function () {
        var menuItems = [];
        if (!this.props.viewState.blockRecipientRemoval) {
            menuItems.push({
                key: 'remove',
                name: owa_common_strings_1.default.readWriteRecipientMenu_Remove,
                onClick: this.removeRecipient,
            });
        }
        menuItems.push({
            key: 'copyAddress',
            name: owa_common_strings_1.default.readWriteRecipientMenu_Copy,
            onClick: this.copyAddress,
        });
        return menuItems;
    };
    ReadWriteRecipient.prototype.getPersonaSizeFromRecipientWellSize = function (size) {
        switch (size) {
            case 0 /* Small */:
                return Persona_1.PersonaSize.size24;
            case 1 /* Regular */:
                return Persona_1.PersonaSize.size32;
            default:
                throw new Error('Cannot get persona size for unknown recipient well size');
        }
    };
    ReadWriteRecipient.prototype.render = function () {
        var _this = this;
        var viewState = this.props.viewState;
        var email = viewState.persona.EmailAddress;
        var isSmallSize = this.props.size == 0 /* Small */;
        var isRegularSize = this.props.size == 1 /* Regular */;
        var personaSize = this.getPersonaSizeFromRecipientWellSize(this.props.size);
        var isExpandable = (email.MailboxType == 'PrivateDL' ||
            email.MailboxType == 'PublicDL' ||
            email.MailboxType == 'GroupMailbox') &&
            this.props.viewState.persona.PersonaId;
        var personaInfo = (React.createElement("div", { className: styles.personaInfoWrapper },
            React.createElement(PersonaControl_1.default, { className: styles.recipientImg, name: viewState.displayText, emailAddress: email.EmailAddress, size: personaSize }),
            React.createElement("span", { className: classNames(styles.recipientText, { invalid: !viewState.isValid }, { selected: viewState.isSelected }, { smallSize: isSmallSize }, { regularSize: isRegularSize }) }, viewState.displayText)));
        return (React.createElement("div", { className: classNames(styles.recipientBox, {
                boxWithPrivateDl: isExpandable,
                selected: viewState.isSelected,
                smallSize: isSmallSize,
                regularSize: isRegularSize,
            }) },
            React.createElement(Button_1.IconButton, { className: classNames(styles.expandGroupButton, {
                    smallSize: isSmallSize,
                    regularSize: isRegularSize,
                }, styles.actionButton, {
                    visible: isExpandable,
                    noHover: viewState.isExpanding,
                    selected: viewState.isSelected,
                }), onClick: this.expandGroup, iconProps: {
                    iconName: "Add" /* Add */,
                } }),
            React.createElement("span", { className: classNames(styles.recipient), ref: function (ref) { return (_this.personaSpan = ref); }, tabIndex: -1, onMouseDown: this.onMouseDown, onBlur: this.onBlur, onKeyDown: this.onKeyDown, onFocus: this.onFocus, onContextMenu: this.onContextMenu, role: "button", "aria-haspopup": "true" },
                email.EmailAddress ? (React.createElement(LPCComposeRecipientWrapper, { emailAddress: email.EmailAddress, name: viewState.displayText, mailBoxType: email.MailboxType, disableHoverAndKeyPress: true }, personaInfo)) : (personaInfo),
                !this.props.viewState.blockRecipientRemoval && (React.createElement(Button_1.IconButton, { className: classNames(styles.removeRecipient, {
                        smallSize: isSmallSize,
                        regularSize: isRegularSize,
                    }, styles.actionButton, {
                        selected: viewState.isSelected,
                    }), onClick: this.removeRecipient, iconProps: {
                        iconName: "Cancel" /* Cancel */,
                    } })),
                viewState.isContextMenuOpen && (React.createElement(ContextualMenu_1.ContextualMenu, { items: this.createContextMenuItems(), onDismiss: this.onDismissContextMenu, target: this.personaSpan, directionalHint: 4 /* bottomLeftEdge */ })))));
    };
    ReadWriteRecipient = tslib_1.__decorate([
        mobx_react_1.observer
    ], ReadWriteRecipient);
    return ReadWriteRecipient;
}(React.Component));
exports.default = ReadWriteRecipient;
var LPCComposeRecipientWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(LPCComposeRecipientWrapper, _super);
    function LPCComposeRecipientWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LPCComposeRecipientWrapper.prototype.render = function () {
        return React.createElement("span", { onClick: this.props.onPersonaCardBehaviorClick }, this.props.children);
    };
    LPCComposeRecipientWrapper = tslib_1.__decorate([
        PersonaCardBehavior_1.personaCardBehavior
    ], LPCComposeRecipientWrapper);
    return LPCComposeRecipientWrapper;
}(React.Component));
//# sourceMappingURL=ReadWriteRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/components/ReadWriteRecipient.js
// module id = 3181
// module chunks = 2 3